/**
 * Default rich HTML for check-in rules (TipTap / same pattern as stamp ops PWA config modal).
 */
export const DEFAULT_CHECKIN_RULES_HTML = `
    <ol>
      <li>Open the check-in page each calendar day.</li>
      <li>Tap check in to record your visit and grow your streak.</li>
      <li>Rewards unlock on configured milestone days.</li>
      <li>If you miss a day, your streak may reset depending on operator settings.</li>
    </ol>
  `;

export function plainTextLengthFromHtml(html) {
  return String(html || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim().length;
}
